module.exports = __webpack_public_path__ + "img/presentation_POE.e8fd330b.webp";